// src/data/eventData.js
const eventData = [
  {
    slug: "graduation-day-alumni-awards",
    title: "Graduation Day & Alumni Awards",
    date: "Sun, 02 Mar 2025",
    location: "Bengaluru",
    description:
      "A special day marking the achievements and dedication of our graduates & alumni.",
    mainContent: [
      "🎓 NIECCE Graduation Day cum Alumni Awards Event 2025 🎓",
      "Dear Graduates and Alumni,",
      "We are delighted to invite you to the NIECCE Graduation Day cum Alumni Awards Event on March 2nd, 2025. This special day marks the culmination of your hard work, dedication, and achievements. We welcome you all!"
    ],
    image:
      "https://static.wixstatic.com/media/6870b3_eab6db776b5c4c67920ec301bbb212ef~mv2.jpg",
    timeLocation: {
      time: "02 Mar 2025, 9:30 am – 1:30 pm",
      venue:
        "Bengaluru, KASSIA Udyog Auditorium, Above D-Mart, Near Hosahalli Metro Station, Vijayanagar, Bengaluru"
    },
    aboutEvent: [
      "🎓 NIECCE Graduation Day cum Alumni Awards Event 2025 🎓",
      "Dear Graduates and Alumni,",
      "We are delighted to invite you to the NIECCE Graduation Day cum Alumni Awards Event on March 2nd, 2025. This special day marks the culmination of your hard work, dedication, and achievements, and we are excited to celebrate it with you.",
      "Join us for an inspiring ceremony as we honor our graduates and recognize the outstanding contributions of our distinguished alumni. It will be an occasion to reconnect with old friends, network with fellow professionals, and reflect on the journey that has led us to this moment.",
      "Date: March 2nd, 2025",
      "Venue: KASSIA Udyog Auditorium",
      "Time: 9:30 am – 1:30 pm",
      "Let's come together to celebrate excellence, share our stories, and build a brighter future. We look forward to seeing you there!"
    ],
    mapEmbed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31158.78978454691!2d77.53796312407419!3d12.973783672738637!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1670b1b9e933%3A0x7f6b9d0e3a88a622!2sVijayanagar%2C%20Bengaluru!5e0!3m2!1sen!2sin!4v1699999999999!5m2!1sen!2sin"
  },
  {
  slug: "positive-parenting-workshop",
  title: "Positive Parenting Workshop for Parents & Teachers!",
  date: "Sat, 09 Dec 2023",
  location: "Bengaluru",
  description: "Understanding the learning patterns of children. Parenting Tips & Tricks. Doing things rightly as a parent.",
  mainContent: [
    "Positive Parenting Workshop for Parents & Teachers!",
    "Understanding the learning patterns of children.",
    "Parenting Tips & Tricks.",
    "Doing things rightly as a parent.",
    "Registration is closed",
    "See other events"
  ],
  image:
    "https://static.wixstatic.com/media/6870b3_acaef89c412d4de18fe391423c03439c~mv2.png",
  timeLocation: {
    time: "09 Dec 2023, 10:00 am – 1:00 pm",
    venue:
      "Bengaluru, 13, 1st cross, Post, opp. Sambram College, Muniswamy Layout, Someshwara Layout, Vidyaranyapura, Bengaluru, Karnataka 560097, India"
  },
  aboutEvent: [
    "Positive Parenting Workshop for Parents & Teachers!",
    "This workshop is designed to help parents understand the learning patterns of children and develop effective strategies to support their growth.",
    "Learn practical parenting tips & tricks that can be applied daily.",
    "Join other parents in discussions and activities to understand doing things rightly as a parent.",
    "Empower yourself to create a positive and nurturing environment for your child."
  ],
 mapEmbed:
  "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d31490.0!2d77.5577!3d13.0766!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m5!1s0x3bae1752c7a792d9%3A0x0!2zMTPCsDA0JzMwLjAiTiA3N8KwMzMnMTUuMCJF!3m2!1d13.0766!2d77.5577!5e0!3m2!1sen!2sin!4v1699999999999"
},
{
  slug: "free-pre-primary-teacher-training",
  title: "Free Pre‑Primary Teacher Training - Playgroup, Nursery, LKG, UKG",
  date: "Sat, 25 Nov 2023",
  location: "Kushalnagar",
  description:
    "We invite all the pre‑primary (Playgroup, Nursery, LKG, UKG) teachers, the principals and the management for this workshop that provides methods of teaching tools and techniques for delivering effective preschool education.",
  mainContent: [
    "Free Pre‑Primary Teacher Training - Playgroup, Nursery, LKG, UKG",
    "We invite all the pre‑primary (Playgroup, Nursery, LKG, UKG) teachers, the principals and the management for this workshop that provides methods of teaching tools and techniques for delivering effective preschool education.",
    "Registration is closed",
    "See other events"
  ],
  image:
    "https://static.wixstatic.com/media/6870b3_e074678ce4704e69918582b1e316543f~mv2.jpg",
  timeLocation: {
    time: "25 Nov 2023, 9:30 am – 4:00 pm",
    venue:
      "Kushalnagar, FX57+8JP, Kushalnagar, Karnataka 571234, India"
  },
  aboutEvent: [
    "Free Pre‑Primary Teacher Training - Playgroup, Nursery, LKG, UKG",
    "This workshop is designed for playgroup, nursery, LKG, and UKG teachers, as well as school principals and management.",
    "You will learn effective tools and techniques for delivering quality preschool education.",
    "The day-long training includes interactive sessions, practical exercises, and best practices for early childhood education."
  ],
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14647.2!2d75.96083!3d12.45697!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m5!1s0x3bae2ef7e5d66413%3A0x0!2zMTLCsDI3JzI4LjAiTiA3NcKwNTYnMDcuMCJF!3m2!1d12.45697!2d75.96083!5e0!3m2!1sen!2sin"
}
];

export default eventData;
